import { Container, Sprite, Texture } from "pixi.js";
import { TPaintingData } from "~/src/config/paintings";
import { EventBus } from "~/src/event-bus";
import { checkIsMobile } from "~/src/utils/check-is-mobile";

const DEFAULT_HEIGHT = 450;
export class PaintingComponent {
  public sprite: Sprite;
  constructor(
    public data: TPaintingData,
    private texture: Texture,
    private eventBus: EventBus
  ) {}
  private calcHeight(): number {
    const { clientHeight } = document.documentElement;
    if (checkIsMobile()) {
      return clientHeight * 0.35;
    }
    return Math.min(DEFAULT_HEIGHT, clientHeight * 0.5);
  }
  updateScale() {
    const scale = this.calcHeight() / this.sprite.texture.height;
    this.sprite.scale.set(scale, scale);
  }
  mount(container: Container) {
    const sprite = new Sprite(this.texture);
    this.sprite = sprite;
    this.updateScale();
    sprite.interactive = true;
    sprite.cursor = 'pointer';
    container.addChild(sprite);
    this.sprite = sprite;
    this.sprite.on("pointerdown", () => {
      this.eventBus.emit("painting/click", this.data);
    });
  }
}
